module.exports = __webpack_public_path__ + "img/89.d577d72b.jpg";